/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import axios from "axios";
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import PageTitle from 'examples/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import DataTable1 from 'react-data-table-component';
import { Link, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { appConstants } from "utils/appConstants";

let LOGIN_DETAILS;

function AddBusinessUserChecklist() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [businessUserName, setBusinessUserName] = useState([]);
  const [screenName, setScreenName] = useState("Add Bussiness User CheckList");

  const [values, setValues] = React.useState({});

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  useEffect(() => {
    fetchChecklist();
    fetchBusinessUserName();
  }, []);






  const handleChange1 = ({ selectedRows }) => {
    // Extracting the _id, cargoLength, cargoBreadth, and cargoHeight from the selectedRows object
    const selectedIds = selectedRows.map(row => row._id);
    console.log('Selected IDs:', selectedIds);


    values.selectedCheckListID = selectedIds;

    // Calculate the loaded volume for each selected order item and store in separate variables


    // selectedRows.forEach(row => {
    //   const { _id, lengthInMm, breadthInMm, heightInMm, weightInKg } = row;
    //   const itemLoadedVolume = lengthInMm * breadthInMm * heightInMm;
    //   console.log(`Loaded Volume for Order Item ${_id}:`, itemLoadedVolume);
    //   loadedVolume += itemLoadedVolume; // Accumulate the loaded volumes

    //   const itemLoadedWeight = weightInKg;
    //   console.log(`Loaded Weight for Order Item ${_id}:`, itemLoadedWeight);
    //   loadedWeight += itemLoadedWeight;
    // });

    // Check if loadedVolume is greater than balanceVolume
    // if (loadedVolume > parseFloat(values.balanceVolume)) {
    //   console.log('Loaded Volume is more than available space!');
    //   swal({
    //     title: "Kindly Choose other Slot Because Added Item Volume is more than Available Space",
    //     text: "",
    //     icon: "error",
    //     color: 'red',
    //     button: false,
    //     timer: 3000
    //   });
    //   return; // Return early if loaded volume exceeds available space
    // } else {
    //   setValues(prevValues => ({
    //     ...prevValues,
    //     orderItemID: selectedIds,
    //     loadedVolume: loadedVolume.toString(), // Convert loadedVolume to string
    //     loadedWeight: loadedWeight.toString(), // Convert loadedWeight to string
    //   }));
    // }
  };

  const fetchBusinessUserName = async () => {
    setLoading(true);
    axios.post(appConstants.baseURL + 'checklist/fetchBusinessUserName', values)
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          setBusinessUserName(response.Result_Output);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchBusinessUserName=", error);
      });
  };

  const fetchChecklist = async () => {
    setLoading(true);
    await axios.post(appConstants.baseURL + 'checklist/fetchChecklist', values)
      .then((res) => {
        setLoading(false);

        console.log("res.data.Result_Output", res.data.Result_Output)
        setRows(res.data.Result_Output);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchChecklist=" + JSON.stringify(error));
      });
  };

  let FetchBusinessUSerName =
    businessUserName.length > 0 &&
    businessUserName.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.firstName} {item.lastName}

        </MenuItem>
      );
    }, this);


  const checklistColm = [
    {
      name: <h3>Checklist Name</h3>,
      selector: "checkListName",
      style: { fontSize: "16px" },
      sortable: true,
      align: "center",
    },
    {
      name: <h3>Checklist Sequence</h3>,
      selector: "checkListSequence",
      align: "center",
      style: { fontSize: "16px" },
      sortable: true,
    },

    {
      name: <h3>Checklist Type</h3>,
      selector: "checkListType",
      style: { fontSize: "16px" },
      sortable: true,
    },



  ];


  const addBussinessUserCheckList = async () => {
    try {

      if (id === undefined) {
        setLoading(true);
        await axios
          .post(appConstants.baseURL + "checklist/addBussinessUserCheckList", values)
          .then((res) => {
            setLoading(false);
            let response = res.data;
            if (response.Result_Status) {
              swal({
                title: "Added successfully!",
                text: " ",
                icon: "success",
                color: "green",
                button: false,
                timer: 2000,
              });
              setTimeout(() => {
                window.location.href = '/newChecklist';
              }, 1000);
            } else {
              swal({
                title: response.Result_Message,
                text: " ",
                icon: "error",
                color: "red",
                button: false,
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log("Error in addNewUser=", error);
          });
      } else {
        setLoading(true);
        await axios
          .post(appConstants.baseURL + "user/addBussinessUserCheckList", values)
          .then((res) => {
            setLoading(false);
            let response = res.data;
            if (response.Result_Status) {
              swal({
                title: "Updated successfully!",
                text: " ",
                icon: "success",
                color: "green",
                button: false,
                timer: 5000,
              });
              setTimeout(() => {
                window.location.href = "/users";
              }, 1000);
            } else {
              swal({
                title: response.Result_Message,
                text: "Please check the User Fields",
                icon: "error",
                color: "red",
                button: false,
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log("Error in fetchStates=", error);
          });
      }
    } catch (error) {
      setLoading(false);
      console.log("In Catch of addNewUser==", error);
    }
  };





















  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={12} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={12} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <PageTitle screenName={screenName} />

              <Grid
                container
                p={4}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >


                <Grid container spacing={2}>
                  <Grid item xs={12} lg={8}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Business User Name </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          label="Business User Name "
                          value={values.businessUserID}
                          onChange={handleChange("businessUserID")}
                        >
                          {FetchBusinessUSerName}
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                </Grid>

                <DataTable1
                  title="Select Item"
                  columns={checklistColm}
                  data={rows}
                  defaultSortFieldId={1}
                  pagination
                  highlightOnHover
                  selectableRows
                  onSelectedRowsChange={handleChange1}
                />

                <Grid container mt={2} columnSpacing={4} alignItems="center" display="flex" justifyContent="center">
                  <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                    <Link to={'/newChecklist'}>
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"
                        fullWidth
                        onClick={() => { sessionStorage.setItem("PARA_TABLE", "BusinessUserChecklist"); }}
                      >
                        Cancel
                      </MDButton>
                    </Link>
                  </Grid>
                  <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      fullWidth
                      onClick={addBussinessUserCheckList}
                    >
                      {id === undefined ? 'Save' : 'Update'}
                    </MDButton>
                  </Grid>
                </Grid>


              </Grid>
            </Card>

          </Grid>
        </Grid>


      </MDBox>









    </DashboardLayout>
  );
}

export default AddBusinessUserChecklist;
